import { Offer } from '../../../shared-html-components/details/offer';
import { CaseObject, CaseDetails } from '../../../shared-html-components/details/details.component';
import { CustomerDetails, Fitter, CompanyInformation } from '../../../shared-html-components/details/models';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from '../../../../assets/js/vfs_fonts.js';
import { Observable, Subject } from 'rxjs';
import { DocumentCreatorGridConversions, GetOffer, JoinedProduct, Product } from 'app/shared-html-components/document-creator/productGrid';
import { ProductTableGroupAccounting } from 'app/shared-html-components/document-creator/product-table/productTableFunctions';
import { HtmlConvertor } from './htmlConversion';
import { format } from 'date-fns';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export class PDFCreate {
  private jublo = new JubloToPdfMakeContent();

  private context = new ContentProvider();
  public template: Template;
  public settings;

  public isUpdating = false;
  public currentPdf;
  public generatedPdfData;
  private header;
  private content;
  private footer;
  public images = [];
  private style;
  public builtData;
  public pdfBlob = new Subject();
  public pdfData = new Subject();
  public createPDFdata = new Subject();

  fonts = {
    Arial: {
      normal: 'Arial-Regular.ttf',
      bold: 'Arial-Bold.ttf',
      italics: 'Arial-Italics.ttf',
      bolditalics: 'Arial-BoldItalics.ttf'
    },
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf'
    },
    Times: {
      normal: 'Times-Regular.ttf',
      bold: 'Times-Bold.ttf',
      italics: 'Times-Italic.ttf',
      bolditalics: 'Times-BoldItalic.ttf'
    },
    Ubuntu: {
      normal: 'Ubuntu-Regular.ttf',
      bold: 'Ubuntu-Bold.ttf',
      italics: 'Ubuntu-Italic.ttf',
      bolditalics: 'Ubuntu-BoldItalic.ttf'
    },
    Verdana: {
      normal: 'Verdana-Regular.ttf',
      bold: 'Verdana-Bold.ttf',
      italics: 'Verdana-Italics.ttf',
      bolditalics: 'Verdana-BoldItalics.ttf'
    }

  }

  constructor() {
    this.jublo.image.subscribe((data: string) => { if (!!data) this.images.push({ name: data, id: data }) })
  }

  public async insertCaseObject(caseData: CaseObject) {
    this.isUpdating = true;
    await this.setOffer(caseData.offer);
    await this.setCompanyDetails(caseData.companyInformation);
    await this.setCaseDetails(caseData.data);
    await this.setStyle(caseData.pdfSettings)
    //this.template = caseData.pdfSettings.template
    this.parsePDF();
  }

  public async setOffer(offer: GetOffer) {
    await this.context.offerDetails(offer);
    //this.parsePDF('offer');
  }

  public async updateOffer(offer: GetOffer) {
    this.isUpdating = true;
    await this.context.offerDetails(offer);
    await this.parsePDF();
  }

  public setCompanyDetails(companyInfo: CompanyInformation) {
    this.context.companyDetails = companyInfo;
    this.images.push({ name: 'logo', base64: companyInfo.base64, id: companyInfo.logo, removeable: false });
  }

  public setCaseDetails(caseDetails: CaseDetails) {
    this.context.case(caseDetails);
    //console.log('case details added to pdf')
  }

  public setOfferPDFDesign(template) {
    this.template = template;
  }

  public setStyle(settings) {
    //console.log('pdf style set in pdf',settings)
    this.settings = settings;
  }

  public setStyleStyle(style) {
    //console.log('Set style style',this.settings, style)
    this.settings['styles'] = style
  }

  async parsePDF() {
    if (!!this.context.compDetails && !!this.template.header && !!this.settings) {
      let h = await this.jublo.handle(this.template.header, this.context.texts, this.context.conditionals, 'header', this.images, this.settings.styles.head, this.context.offDetails, this.context.lines)
      let f = await this.jublo.handle(this.template.footer, this.context.texts, this.context.conditionals, 'footer', this.images, this.settings.styles.foot, this.context.offDetails, this.context.lines)
      this.header = (currentPage, pageCount) => { return JSON.parse(JSON.stringify(h).replace('[currentPage]', currentPage).replace('[pageCount]', pageCount)) };
      this.content = await this.jublo.handle(this.template.content, this.context.texts, this.context.conditionals, 'content', this.images, this.settings.styles.mainStyle, this.context.offDetails, this.context.lines);
      this.footer = (currentPage, pageCount) => { return JSON.parse(JSON.stringify(f).replace('[currentPage]', currentPage).replace('[pageCount]', pageCount)) };
      let i = await this.getImageObject();
      //this.jublo.html.saveTextAsFile(JSON.stringify(this.content, null, 4));
      //this.jublo.html.saveTextAsFile(JSON.stringify(this.template.footer, null, 4));
      this.builtData = {
        header: this.header,
        content: this.content,
        footer: this.footer,
        images: i
      }
      this.buildPdfData()
    } else {
      console.log('Could not parse, lacks information')
      console.log('Company Details: ', !!this.context.compDetails)
      console.log('Template: ', !!this.template.header)
      console.log('Style: ', !!this.settings)
    }

  }

  async getImageObject() {
    let i = {}
    await this.images.forEach(x => i[x.name] = 'https://jubloapi.azure-api.net/api/shared/attachments/' + x.id);
    // get the klarPris images as well?
    // await this.context.lines.filter(x => x.type == 'product' && !!x.image ).forEach(x => i[x.id] = x.image)
    // console.log(i)
    return i
  }

  async buildPdfData() {
    if (!!this.header && !!this.content && !!this.footer) {
      let document = await {
        pageMargins: this.settings.styles.page,
        header: this.header,
        footer: this.footer,
        content: this.content,
        images: this.builtData.images,
        styles: this.settings.styles
      }
      this.updatePdf(document)
    }

  }

  async updatePdf(document) {
    this.generatedPdfData = await pdfMake.createPdf(document, null, this.fonts);
    this.createPDFdata.next(this.generatedPdfData)
    this.isUpdating = false;
    await this.generatedPdfData.getDataUrl((data) => {
      this.currentPdf = data;
      this.pdfData.next(data);
    });
    await this.generatedPdfData.getBlob((blob: Blob) => {
      this.pdfBlob.next(blob);
    })
  }
}

export class JubloToPdfMakeContent {
  html = new HtmlToPdfMake();
  h = new HtmlConvertor();
  image = new Subject();
  async handle(contentArray: Array<pdfParts>, texts, conditions, placement, images, parentStyle: defaultStyle, offer: GetOffer, lines) {
    let a = this.h.image.subscribe((data) => { this.image.next(data) });
    let outputArray = [];
    let output = { stack: [] }
    if (!!parentStyle['font']) {
      output['font'] = parentStyle['font']
    }
    output['fontSize'] = !!parentStyle['fontSize'] ? parentStyle['fontSize'] : 10;
    output['margin'] = placement != 'content' && !!parentStyle['margin'] ? parentStyle['margin'] : [0, 0, 0, 0];
    output['lineHeight'] = parentStyle['lineHeight'] ? parentStyle['lineHeight'] : 1;
    for (let item of contentArray) {
      if (!!item.condition && !conditions[item.condition]) {
        continue;
      }
      let response = await this.handleSubItem(item, texts, offer, conditions, placement, images, parentStyle, lines);
      if (!!item.pageBreak) response['pageBreak'] = item.pageBreak;
      if (!!response) {
        outputArray.push(response);
      }
    }
    // this.html.saveTextAsFile(JSON.stringify(outputArray, null, 4))
    output.stack = outputArray;
    a.unsubscribe();
    return output;
  }

  async handleSubItem(item, texts, offer, conditions, placement, images, parentStyle, lines) {
    let response;
    switch (item.type) {
      case ('stack'): { return await this.handleStack(item, texts, offer, conditions, placement, images, parentStyle, lines) }
      case ('columns'): { return await this.handleColumns(item, texts, offer, conditions, placement, images, parentStyle, lines) }
      case ('table'): { return await this.handleTables(item, texts, offer, conditions, placement, images, parentStyle, lines) }
      case ('compositeText'): { return await this.handleCompositeText(item, texts, offer, conditions, placement, images, parentStyle, lines) }
      case ('productTable'): { return await this.newProductTable(item, offer, texts, conditions, parentStyle, lines) }
      case ('productPage'): { return await this.handleProductPage(item, texts, offer, lines, conditions, parentStyle) }
      case ('sumTotal'): { return await this.handleSumTotals(item, texts, offer, lines, conditions, parentStyle) }
      case ('absolute'): { return await this.handleAbsolute(item, texts, offer, conditions, placement, images, parentStyle, lines) }
      case ('line'): { return await this.handleLine(item) }
      case ('date'): { return await this.handleDate(item, parentStyle, conditions) }
      default: { return await this.handleSingleItem(item, texts, offer, conditions, placement, images, parentStyle) }
    }
  }

  async handleColumns(object: pdfParts, texts, offer, conditions, placement, images, parentStyle: defaultStyle, lines) {
    this.html.startingStyle = parentStyle;
    // width, alignment have no predictable effect on columns
    //
    // Setup standard column, so that all columns have all options form start
    let standardColumn = { columns: [], columnGap: 20 }
    if (!!object.fontSize) { standardColumn['fontSize'] = object.fontSize }
    if (!!object.bold) { standardColumn['bold'] = object.bold }
    if (!!object.italics) { standardColumn['italics'] = object.italics }
    if (!!object.lineHeight) { standardColumn['lineHeight'] = object.lineHeight }
    if (!!object.margin) { standardColumn['margin'] = object.margin }
    if (!!object.font) { standardColumn['font'] = object.font }
    if (!!object.width) {
      standardColumn['width'] = object.width
    }
    // create a new style for child objects
    for (let i of object.columns) {
      if (!!i.condition && !conditions[i.condition]) {
        continue
      }
      if (i.type != 'none' && ['text', 'line', 'image'].includes(i.type)) {
        let itemInColumn = await this.handleSingleItem(i, texts, offer, conditions, placement, images, parentStyle)
        standardColumn.columns.push(itemInColumn)
      }
      else {
        switch (i.type) {
          case ('table'): {
            let tableInColumns = await this.handleTables(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardColumn.columns.push(tableInColumns)
              ; break
          }
          case ('stack'): {
            let stackInColumns = await this.handleStack(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardColumn.columns.push(stackInColumns)
              ; break
          }
          case ('columns'): {
            let columnInColumns = await this.handleColumns(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardColumn.columns.push(columnInColumns)
              ; break
          }
          case ('compositeText'): {
            let composite = await this.handleCompositeText(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardColumn.columns.push(composite);
            break
          }
          case ('date'): {
            let date = await this.handleDate(i, parentStyle, conditions);
            standardColumn.columns.push(date)
            break
          }
        }

      }
    }
    return standardColumn
  }

  async handleTables(object: pdfParts, texts, offer, conditions, placement, images, parentStyle: defaultStyle, lines) {
    let standardTable: TableContent = {
      table: {
        headerRows: object.headers,
        body: [],
        widths: []
      },
      layout: '',
      margin: parentStyle.margin
    }
    if (!!object.margin) { standardTable.margin = object.margin }
    if (!!object.font) { standardTable['font'] = object.font }
    if (!!object.fontSize) { standardTable['fontSize'] = object.fontSize }
    if (!!object.lineHeight) { standardTable['lineHeight'] = object.lineHeight }
    if (!!object.bold) { standardTable['bold'] = object.bold }
    if (!!object.italics) { standardTable['italics'] = object.italics }
    for (let row of object.tableRows) {
      let outputRow = await this.handleTableRows(row, texts, offer, conditions, placement, images, parentStyle, lines);
      standardTable.table.body.push(outputRow)
    }
    for (let width of object.tableWidths) {
      let currentWidth = await this.translateNumberToPdfMakeWidth(width);
      standardTable.table.widths.push(currentWidth)
    }
    switch (object.tableType) {
      case ('none'): { standardTable.layout = 'noBorders'; break }
      case ('horizontal'): { standardTable.layout = 'lightHorizontalLines'; break }
      case ('header'): { standardTable.layout = 'headerLineOnly'; break }
    }
    return standardTable
  }

  async handleTableRows(row, texts, offer, conditions, placement, images, parentStyle, lines) {
    let outputRow = []
    for (let item of row) {
      if (!!item.condition && !conditions[item.condition]) {
        outputRow.push({ text: '' });
        continue
      }
      if (['stack', 'columns', 'table', 'compositeText'].includes(item.type)) {
        switch (item.type) {
          case ('stack'): {
            let stackData = await this.handleStack(item, texts, offer, conditions, placement, images, parentStyle, lines);
            outputRow.push(stackData)
              ; break
          }
          case ('columns'): {
            let columnData = await this.handleColumns(item, texts, offer, conditions, placement, images, parentStyle, lines)
            outputRow.push(columnData)
              ; break
          }
          case ('table'): {
            let tableData = await this.handleTables(item, texts, offer, conditions, placement, images, parentStyle, lines)
            outputRow.push(tableData)
              ; break
          }
          case ('compositeText'): {
            let composite = await this.handleCompositeText(item, texts, offer, conditions, placement, images, parentStyle, lines)
            outputRow.push(composite)
              ; break
          }
          case ('date'): {
            let date = await this.handleDate(item, parentStyle, conditions)
            outputRow.push(date);
            break
          }
        }
      }
      else {
        let itemInRow = await this.handleSingleItem(item, texts, offer, conditions, placement, images, parentStyle)
        outputRow.push(itemInRow)
      }
    }
    return outputRow;
  }

  async handleStack(object, texts, offer, conditions, placement, images, parentStyle: defaultStyle, lines) {
    // Setup standard stack, so that all items in stack have all options form start
    let standardStack = { stack: [] }
    if (!!object.fontSize) { standardStack['fontSize'] = object.fontSize }
    if (!!object.bold) { standardStack['bold'] = object.bold }
    if (!!object.color) { standardStack['color'] = object.color }
    if (!!object.italics) { standardStack['italics'] = object.italics }
    if (!!object.lineHeight) { standardStack['lineHeight'] = object.lineHeight }
    if (!!object.margin) { standardStack['margin'] = object.margin }
    if (!!object.font) { standardStack['font'] = object.font }
    if (!!object.width) { standardStack['width'] = object.width }
    if (!!object.fillColor) { standardStack['fillColor'] = object.fillColor }

    // create a new style for child objects
    for (let i of object.columns) {
      if (!!i.condition && !conditions[i.condition]) {
        continue
      }
      if (['columns', 'table', 'productTable', 'sumTotal', 'compositeText'].includes(i.type)) {
        switch (i.type) {
          case ('stack'): {
            let stackData = await this.handleStack(i, texts, offer, conditions, placement, images, parentStyle, lines);
            standardStack.stack.push(stackData)
              ; break
          }
          case ('columns'): {
            let columnData = await this.handleColumns(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardStack.stack.push(columnData)
              ; break
          }
          case ('table'): {
            let tableData = await this.handleTables(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardStack.stack.push(tableData)
              ; break
          }
          case ('compositeText'): {
            let composite = await this.handleCompositeText(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardStack.stack.push(composite);
            break
          }
          case ('productTable'): {
            let products = await this.newProductTable(i, offer, texts, conditions, parentStyle, lines);
            //console.log('The products came back as', products)
            if (!!products) { standardStack.stack.push(products); }
            ; break
          }
          case ('sumTotal'): {
            let totals = await this.handleSumTotals(i, texts, offer, lines, conditions, parentStyle);
            // console.log('The totals came back as', totals)
            standardStack.stack.push(totals)
          }
        }
      }
      else {
        let stackItem = await this.handleSingleItem(i, texts, offer, conditions, placement, images, parentStyle);
        standardStack.stack.push(stackItem)
      }

    }
    return standardStack
  }

  async handleCompositeText(item, texts, offer, conditions, placement, images, parentStyle, lines) {
    //console.log('composite text', item)
    let a = { ...parentStyle }
    let standardText = { text: [] }
    if (!!item.fontSize && !!parentStyle && item.fontSize != parentStyle.fontSize) { standardText['fontSize'] = item.fontSize; a['fontSize'] = item.fontSize }
    if (!!item.bold && !!parentStyle && item.bold != parentStyle.bold) { standardText['bold'] = item.bold; a['bold'] = item.bold }
    if (!!item.color) { standardText['color'] = item.color }
    if (!!item.italics) { standardText['italics'] = item.italics }
    if (!!item.lineHeight) { standardText['lineHeight'] = item.lineHeight }
    if (!!item.margin) { standardText['margin'] = item.margin }
    if (!!item.font) { standardText['font'] = item.font }
    if (!!item.link) { standardText['link'] = item.link }
    if (!!item.width) { standardText['width'] = item.width }
    if (!!item.alignment) { standardText['alignment'] = item.alignment }
    for (let i of item.columns) {
      if (i.type != 'none' && ['text', 'line', 'image', 'date'].includes(i.type)) {
        let itemInColumn = await this.handleSingleItem(i, texts, offer, conditions, placement, images, a)
        standardText.text.push(itemInColumn)
      }
      else {
        switch (i.type) {
          case ('table'): {
            let tableInColumns = await this.handleTables(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardText.text.push(tableInColumns)
              ; break
          }
          case ('stack'): {
            let stackInColumns = await this.handleStack(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardText.text.push(stackInColumns)
              ; break
          }
          case ('columns'): {
            let columnInColumns = await this.handleColumns(i, texts, offer, conditions, placement, images, parentStyle, lines)
            standardText.text.push(columnInColumns)
              ; break
          }
        }
      }
    }
    //console.log('composite text output', standardText)
    return standardText
  }

  async handleSingleItem(item: pdfParts, texts, offer, conditions, placement, images, parentStyle: defaultStyle) {
    switch (item.type) {
      case ('text'): {
        let text = await this.handleText(item, texts, placement, conditions, parentStyle);
        return text
      }
      case ('image'): {
        let image = await this.handleImage(item, images);
        return image
      }
      case ('line'): {
        return this.handleLine(item)
      }
      case ('date'): { return this.handleDate(item, parentStyle, conditions) }
    }
  }

  async handleText(object, texts, placement, conditions, parentStyle?: defaultStyle) {
    let textOutput: defaultStyle = { text: '', bold: parentStyle.bold, italics: parentStyle.italics, width: parentStyle.width };
    if (!!object.condition && !conditions[object.condition]) {
      console.log('Condition met', object, conditions, conditions[object.condition])
      return textOutput
    }

    let textContent = await this.findReplaceMentText(object, texts, placement, parentStyle);
    if (typeof textContent == 'object') {
      // transfer object style
      textContent = await this.parentStyleToChild(object, textContent)
      if (!!object.color && object.color != '') { textContent['color'] = object.color }
      return textContent
    }
    else { textOutput.text = textContent }
    if (!!object.margin) { textOutput.margin = object.margin }
    if (!!object.color) { textOutput.color = object.color }
    if (!!object.lineHeight) { textOutput['lineHeight'] = object.lineHeight }
    if (!!object.fontSize) { textOutput['fontSize'] = object.fontSize }
    if (!!object.font) { textOutput['font'] = object.font }
    if (!!object.bold) { textOutput['bold'] = object.bold }
    if (!!object.alignment) { textOutput['alignment'] = object.alignment }
    if (!!object.italics) { textOutput['italics'] = object.italics }
    if (!!object.link) { textOutput['link'] = object.link }
    if (!!object.width && object.width <= 0) {
      textOutput.width = object.width == 0 ? '*' : 'auto';
    }
    else { textOutput.width = !!object.width ? object.width : '*' }
    return textOutput
  }

  async findReplaceMentText(textObject, texts, placement, parentStyle?) {
    if (textObject.textType == 'free') { return textObject.text }
    if (!!texts[textObject.text]) {
      if (['offerDisclaimer', 'offerDescription'].includes(textObject.text)) {
        // let returnText = await this.html.parseToPdf(texts[textObject.text], parentStyle);
        let returnText = await this.h.parse(texts[textObject.text], parentStyle);
        // this.h.parseContainer('invisibleDescription');
        // console.log(JSON.parse(JSON.stringify(returnText)))
        return returnText
      }
      else { return JSON.parse(JSON.stringify(texts[textObject.text])) }
    }
    if ((texts[textObject.text] == null || texts[textObject.text] == '') && textObject.textType == 'dynamic') { return '' }
    else { return textObject.text }
  }

  async handleImage(object, images) {
    // Find the image based on the name
    let i = await images.find(x => x.name == object.image)
    // Create standard image item
    let imageOutput = !!i ? { image: object.image, fit: [100, 100], alignment: 'left' } : { text: '' };
    if (!!object.margin) { imageOutput['margin'] = object.margin };
    if (!!object.fit) { imageOutput.fit = object.fit };
    if (!!object.alignment) { imageOutput.alignment = object.alignment }
    if (!!object.width) {
      imageOutput['width'] = object.width > 0 ? object.width : object.width == 0 ? '*' : 'auto';
    }
    return imageOutput
  }

  async handleLine(object) {
    let lineObject: any = { canvas: [{ type: 'line', lineColor: !!object.color ? object.color : 'black', x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 1 }] };
    if (!!object.margin) { lineObject.margin = object.margin }
    if (!!object.color) lineObject.color = object.color;
    return JSON.parse(JSON.stringify(lineObject))
  }

  async handleProductPage(item, texts, offer: Offer, lines, conditions, parentStyle) {
    let visibleLevel = await Math.max(...lines.filter(x => !x.hideOnPdf).map(x => !!x.path ? x.path.split('//').length : 0));
    let fontSizer = !!parentStyle.fontSize ? parentStyle.fontSize : 10;
    var products: Array<any> = [
      [
        { text: 'Antal', fontSize: fontSizer + 2, alignment: 'center', bold: true },
        { text: 'Beskrivelse', fontSize: fontSizer + 2, bold: true }
      ]
    ].concat(
      lines.filter(x => !x.hideOnPdf && !['group', 'comment'].includes(x.type) || x.type == 'group' && this.groupAsLine(x, visibleLevel, lines)).map(x => {
        return [
          { text: x.amount, fontSize: fontSizer, alignment: 'center' }, { text: x.description, fontSize: fontSizer }
        ]
      })
    );
    // for (let line of offer.productLines) {
    //   products.push([{ text: line.quantity, fontSize: fontSizer, alignment: 'center' }, { text: line.description, fontSize: fontSizer }])
    // };
    // for (let line of offer.customLines) {
    //   if (line.priceGroupId == null || offer.showHours == true) { products.push([{ text: line.quantity, fontSize: fontSizer, alignment: 'center' }, { text: line.name, fontSize: fontSizer }]); }
    //   else { products.push([{ text: '', fontSize: fontSizer, alignment: 'center' }, { text: line.name, fontSize: fontSizer }]); }
    // };
    var output = {
      'layout': 'lightHorizontalLines',
      'table': { 'headerRows': 1, 'widths': [80, '*'], 'body': products },
      'margin': [0, 20, 0, 0],
      'pageBreak': !item.pageBreak ? 'before' : !!item.pageBreak && item.pageBreak != 'none' ? item.pageBreak : null
    }
    if (!!item.font) { output['font'] = item.font }
    if (!!item.fontSize) { output['fontSize'] = item.fontSize }
    if (!!item.bold) { output['bold'] = item.bold }
    if (!!item.italics) { output['italics'] = item.italics }
    if (!!item.lineHeight) { output['lineHeight'] = item.lineHeight }
    return output;
  }

  async handleProductTable(object, offer: Offer, texts, conditions, parentStyle, lines) {
    this.newProductTable(object, offer, texts, conditions, parentStyle, lines);
    let useArtNums = object.translates != null && object.translates.useArticleNumber != null && object.translates.useArticleNumber == true ? true : false;
    let fontSizer = !!parentStyle.fontSize ? parentStyle.fontSize : 10;
    let diff = await this.calculateTableDiff(lines, offer);
    fontSizer = !!object.fontSize ? object.fontSize : fontSizer;
    let showDiscount = await this.checkIfProductsHasDiscount(offer);
    let table = [];
    // Insert Table Headers
    switch (useArtNums) {
      case (true): {
        //console.log('using a product table with article numbers')
        if (showDiscount) {
          table.push(
            [
              { text: object.translates['productNumber'] != null ? object.translates['productNumber'] : 'Varenr.', bold: true },
              { text: object.translates['text'], bold: true },
              { text: object.translates['pricePer'], alignment: 'right', bold: true },
              { text: object.translates['amount'], alignment: 'center', bold: true },
              { text: object.translates['discount'], alignment: 'center', bold: true },
              { text: object.translates['price'], alignment: 'right', bold: true }
            ]
          )
        }
        else {
          table.push(
            [
              { text: object.translates['productNumber'] != null ? object.translates['productNumber'] : 'Varenr.', bold: true },
              { text: object.translates['text'], bold: true },
              { text: object.translates['pricePer'], alignment: 'right', bold: true },
              { text: object.translates['amount'], alignment: 'center', bold: true },
              { text: object.translates['price'], alignment: 'right', bold: true }
            ]
          )
        }
        break
      }
      case (false): {
        //console.log('not using a product table with article numbers')
        if (showDiscount) {
          table.push(
            [
              { text: object.translates['text'], bold: true },
              { text: object.translates['pricePer'], alignment: 'right', bold: true },
              { text: object.translates['amount'], alignment: 'center', bold: true },
              { text: object.translates['discount'], alignment: 'center', bold: true },
              { text: object.translates['price'], alignment: 'right', bold: true }
            ]
          )
        }
        else {
          table.push(
            [
              { text: object.translates['text'], bold: true },
              { text: object.translates['pricePer'], alignment: 'right', bold: true },
              { text: object.translates['amount'], alignment: 'center', bold: true },
              { text: object.translates['price'], alignment: 'right', bold: true }
            ]
          )
        }
        break
      }
    }

    // For every ProductLine
    for (let line of lines.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)) {
      let discountLine;
      let originalSale;
      if (line.discount == 0) {
        discountLine = { text: '' };
        originalSale = line.sale
      }
      else {
        discountLine = { text: this.nums(line.discount, texts['companyLingo']) + ' %', alignment: 'center' };
        originalSale = !!line.sale ? +(100 * (line.sale / (100 - line.discount))).toFixed(2) : !!line.cost ? (line.cost) * ((line.profit / 100) + 1) : '';
      }
      console.log('original sale', originalSale)
      switch (useArtNums) {
        case (true): {
          if (showDiscount) {
            table.push([
              { text: line.number != null ? line.number : '' },
              {
                text: line.description,
                bold: line.type == 'group',
                margin: [!!line.path ? (line.path.split('//').length - 1) * 5 : 0, line.type == 'group' ? 5 : 0, 0, 0],
                colSpan: line.type == 'comment' ? 5 : 1
              },
              { text: offer.showHours == true || line.priceGroupId == null ? this.nums(originalSale, texts['companyLingo']) : '', alignment: 'right' },
              { text: offer.showHours == true || line.priceGroupId == null ? line.amount.toString() : '', style: 'tableItem', alignment: 'center' },
              discountLine,
              { text: this.nums(line.sale * line.amount, texts['companyLingo']), alignment: 'right' }
            ]
            )
          }
          else {
            table.push([
              { text: line.number != null ? line.number : '' },
              {
                text: line.description, bold: line.type == 'group', margin: [!!line.path ? (line.path.split('//').length - 1) * 5 : 0, line.type == 'group' ? 5 : 0, 0, 0],
                colSpan: line.type == 'comment' ? 4 : 1
              },
              { text: offer.showHours == true || line.priceGroupId == null ? this.nums(line.sale, texts['companyLingo']) : '', alignment: 'right' },
              { text: (offer.showHours == true || line.priceGroupId == null) && !!line.amount ? line.amount.toString() : '', style: 'tableItem', alignment: 'center' },
              { text: this.nums(line.sale * line.amount, texts['companyLingo']), alignment: 'right' }
            ]
            )
          }
          ; break
        }
        case (false): {
          if (showDiscount) {
            table.push([
              {
                text: line.description, bold: line.type == 'group', margin: [!!line.path ? (line.path.split('//').length - 1) * 5 : 0, line.type == 'group' ? 5 : 0, 0, 0],
                colSpan: line.type == 'comment' ? 5 : 1
              },
              { text: offer.showHours == true || line.priceGroupId == null ? this.nums(originalSale, texts['companyLingo']) : '', alignment: 'right' },
              { text: (offer.showHours == true || line.priceGroupId == null) && !!line.amount ? line.amount.toString() : '', style: 'tableItem', alignment: 'center' },
              discountLine,
              { text: this.nums(line.sale * line.amount, texts['companyLingo']), alignment: 'right' }
            ]
            )
          }
          else {
            table.push([
              {
                text: line.description, bold: line.type == 'group', margin: [!!line.path ? (line.path.split('//').length - 1) * 5 : 0, line.type == 'group' ? 5 : 0, 0, 0],
                colSpan: line.type == 'comment' ? 4 : 1
              },
              { text: offer.showHours == true || line.priceGroupId == null ? this.nums(line.sale, texts['companyLingo']) : '', alignment: 'right' },
              { text: (offer.showHours == true || line.priceGroupId == null) && !!line.amount ? line.amount.toString() : '', style: 'tableItem', alignment: 'center' },
              { text: this.nums(line.sale * line.amount, texts['companyLingo']), alignment: 'right' }
            ]
            )
          }
          ; break
        }
      }

    }
    // Should a fake line be added to products?
    if (object.translates.fakeDifferenceLine != null && Math.abs(diff) > 1) {
      let amount = diff > 0 ? '1' : '-1';
      if (showDiscount) {
        table.push([
          { text: object.translates.fakeDifferenceLine },
          { text: this.nums(Math.abs(diff), texts['companyLingo']), alignment: 'right' },
          { text: amount, alignment: 'center' },
          { text: '' },
          { text: this.nums(+diff, texts['companyLingo']), alignment: 'right' }
        ])
      }
      else {
        table.push([
          { text: object.translates.fakeDifferenceLine },
          { text: this.nums(Math.abs(diff), texts['companyLingo']), alignment: 'right' },
          { text: amount, alignment: 'center' },
          { text: this.nums(diff, texts['companyLingo']), alignment: 'right' }
        ])
      }
    }
    object.tableType = object.tableType == null || object.tableType == 'horizontal' || object.TableType == 'lightHorizontalLines' ? 'lightHorizontalLines' : object.tableType == 'none' || object.tableType == 'noBorders' ? 'noBorders' : 'headerLineOnly';
    // Returning a table object depending on showDiscount
    console.log(
      {
        table: {
          headerRows: 1,
          body: table,
          widths: ['auto', '*', 'auto', 40, 'auto']
        },
        layout: object.tableType,
        fontSize: fontSizer
      }
    )
    switch (useArtNums) {
      case (true): {
        if (showDiscount) {
          return {
            table: {
              headerRows: 1,
              body: table,
              widths: ['auto', '*', 40, 40, 50, 'auto']
            },
            layout: object.tableType,
            fontSize: fontSizer
          }
        }
        else {
          return {
            table: {
              headerRows: 1,
              body: table,
              widths: ['auto', '*', 'auto', 40, 'auto']
            },
            layout: object.tableType,
            fontSize: fontSizer
          }
        }
      }
      case (false): {
        if (showDiscount) {
          return {
            table: {
              headerRows: 1,
              body: table,
              widths: ['*', 'auto', 40, 50, 'auto']
            },
            layout: object.tableType,
            fontSize: fontSizer
          }
        }
        else {
          return {
            table: {
              headerRows: 1,
              body: table,
              widths: ['*', 'auto', 40, 'auto']
            },
            layout: object.tableType,
            fontSize: fontSizer
          }
        }
        ; break
      }
    }
  }

  async newProductTable(object, offer: Offer, texts, conditions, parentStyle, line) {
    let lines = line.filter(x => !x.hideOnPdf);
    let visibleLevel = await Math.max(...lines.filter(x => !x.hideOnPdf).map(x => !!x.path ? x.path.split('//').length : 0));
    let showDiscount = await this.checkIfProductsHasDiscount(offer);
    let useArtNums = !!object.translates && !!object.translates.useArticleNumber;
    let fontSizer = !!object.fontSize ? object.fontSize : !!parentStyle.fontSize ? parentStyle.fontSize : 10;
    let table = [];
    // Insert Table Headers
    table.push([
      { text: !!useArtNums ? (!!object.translates['productNumber'] ? object.translates['productNumber'] : 'Varenr.') : 'UnusedDelete', bold: true },
      { text: object.translates['text'], bold: true },
      { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : object.translates['pricePer'], alignment: 'right', bold: true },
      { text: !!offer.hideAmountOnPDF ? 'UnusedDelete' : object.translates['amount'], alignment: 'center', bold: true },
      { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : !!showDiscount ? object.translates['discount'] : 'UnusedDelete', alignment: 'center', bold: true },
      { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : object.translates['price'], alignment: 'right', bold: true }
    ]
    )
    // For every ProductLine
    let hideNonGroupPrices = !!object.translates && !!object.translates.hideLinePrices;
    let sorted = await this.sortProducts(lines);
    let products = sorted.map(x => {
      let groupAsLine = x.type == 'group' ? (!!hideNonGroupPrices ? true : this.groupAsLine(x, visibleLevel, lines)) : false;
      let discountLine = !!showDiscount ? { text: !!x.discount ? (this.nums(x.discount, texts['companyLingo']) + ' %') : '', alignment: 'center' } : 'UnusedDelete';
      // let originalSale = x.type == 'group' ? x.sale : !!x.discount && !!x.sale ? (+(100 * (x.sale / (100 - x.discount))).toFixed(2)) : !!x.sale ? x.sale : !!x.cost ? (x.cost) * ((x.profit / 100) + 1) : ''; 
      let originalSale = !!x.discount ? ((x.cost) * ((x.profit / 100) + 1)).toFixed(2) : x.sale;
      let total = this.getTotalSale(x, texts, visibleLevel, showDiscount, groupAsLine, hideNonGroupPrices);
      let showPriceAndAmount = x.type == 'group' && groupAsLine || x.type != 'group' && !hideNonGroupPrices && (offer.showHours == true || !x.priceGroupId);
      return [
        { text: !!useArtNums ? (!!x.number ? x.number : '') : 'UnusedDelete' },
        { ...this.descriptionFormatter(x, groupAsLine, offer, object) },
        { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : showPriceAndAmount ? this.nums(+originalSale, texts['companyLingo']) : '', alignment: 'right', margin: x.type == 'group' && !groupAsLine ? [0, 5, 0, 0] : null },
        { text: !!offer.hideAmountOnPDF ? 'UnusedDelete' : showPriceAndAmount && !!x.amount ? x.amount.toString() : '', style: 'tableItem', alignment: 'center', margin: x.type == 'group' && !groupAsLine ? [0, 5, 0, 0] : null },
        { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : discountLine, alignment: 'center' },
        { text: !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? 'UnusedDelete' : total, alignment: 'right', margin: x.type == 'group' && !groupAsLine ? [0, 5, 0, 0] : null }
      ]
    });
    // Productno. , Description , Price per, Amount, Total Price
    table = await table.concat(products).map(x => x.filter(y => y.text != 'UnusedDelete'));
    object.tableType = object.tableType == null || object.tableType == 'horizontal' || object.TableType == 'lightHorizontalLines' ? 'lightHorizontalLines' : object.tableType == 'none' || object.tableType == 'noBorders' ? 'noBorders' : 'headerLineOnly';
    let widths = !!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF ? [!!useArtNums ? 'auto' : 'UnusedDelete', '*', !!offer.hideAmountOnPDF ? 'UnusedDelete' : 'auto'].filter(x => x != 'UnusedDelete') : await [
      !!useArtNums ? 'auto' : 'UnusedDelete', // product number
      '*', // description
      'auto', // price per unit
      !!offer.hideAmountOnPDF ? 'UnusedDelete' : 40, // amount
      !!showDiscount ? 40 : 'UnusedDelete', // discount
      'auto' // total price
    ].filter(x => x != 'UnusedDelete');
    // console.log(widths)
    return {
      table: {
        headerRows: 1,
        body: table,
        widths: widths
      },
      layout: object.tableType,
      fontSize: fontSizer
    }
  }

  async sortProducts(lines: Product[]): Promise<Product[]> {
    const tree = this.convertToTree(lines,{});
    // Step 4: Flatten the tree into a sorted array
    return this.flatten(tree);
  }
  
  convertToTree(products: any[], groupStates:any): Product[] {
    const productPaths: Record<string, any> = {};
    const groups = products.filter(x => x.type == 'group');
    const groupPaths = groups.map(x => x.path);

    let baseTree = products.filter(x => x.type != 'group' && (!x.path || !groupPaths.includes(x.path)));

    const childProducts = products.filter(x => x.type != 'group' && !!x.path && groupPaths.includes(x.path));
    // Map each group by its path
    groups.forEach(group => {
        productPaths[group.path] = group;
        group.children = [];
        group.isOpen = !!groupStates && groupStates[group.path] != undefined ? groupStates[group.path] : false
    });

    // Assign child products to their respective groups
    childProducts.forEach(product => {
        const parentPath = product.type == 'group' ? product.path.split('//').slice(0, -1).join('//') : product.path;
        if (productPaths[parentPath]) productPaths[parentPath].children.push(product); 
    });

    // Assign groups to their respective parent groups
    groups.forEach(group => {
        const parentPath = group.path.split('//').slice(0, -1).join('//') || null;
        if (parentPath && productPaths[parentPath]) productPaths[parentPath].children.push(group);
        else baseTree.push(group);
    });

    // Sort the base tree and children recursively
    const sortProducts = (products: Product[]) => {
        products.sort((a, b) => a.sortOrder - b.sortOrder);
        products.forEach(product => { if (product.children) sortProducts(product.children); });
    };
    sortProducts(baseTree);

    return baseTree;
  }
  
  flatten(products: any[]): Promise<Product[]>{
    let flatList: Product[] = [];
    return new Promise((resolve) => {
        const flattenTree = (products: Product[], flatList: Product[], startIndex: number) => {
            products.forEach((product, index) => {
                product.sortOrder = index + startIndex;
              flatList.push(product);
              if (product.children && product.children.length > 0) {
                flattenTree(product.children, flatList, index + 1);
              }
            });
        };
        flattenTree(products, flatList,0);
        resolve( flatList);
    });
  }

  descriptionFormatter(x: JoinedProduct, groupAsLine, offer, object) {
    // colSpan error for comment if
    return {
      text: x.description,
      bold: x.type == 'group',
      margin: [!!x.path ? (x.path.split('//').length - (x.type == 'group' ? 1 : 0)) * 15 : 0, ['group', 'comment'].includes(x.type) && !groupAsLine ? 5 : 0, 0, x.type == 'comment' ? 5 : 0],
      colSpan: x.type != 'comment' ? 1 : this.getCommentSpan(x, groupAsLine, offer, object)
    }
  }

  getCommentSpan(x: JoinedProduct, groupAsLine, offer, object) {
    let span = 4;
    if (!!object.translates.hideAllPrices || !!offer.hideProductPricesOnPDF) span -= 2;
    if (!!offer.hideAmountOnPDF) span -= 1;
    return span;
  }

  groupAsLine(line, visibleLevel, lines) {
    if (lines.filter(x => x.type != 'comment' && x.path == line.path && x.id != line.id).length == 0) {
      return true
    }
    return false
  }

  getTotalSale(line, texts, visibleLevel, showDiscount, groupAsLine, hideNonGroupPrices) {
    if (line.type == 'group' && groupAsLine) {
      return this.nums(line.totalSale, texts['companyLingo'])
    }
    if (!['group', 'comment'].includes(line.type)) {
      return !hideNonGroupPrices ? this.nums(line.totalSale, texts['companyLingo']) : '';
    }
    return ''
  }

  getOriginalSaleFromLine(line) {
    if (!!line.discount && !!line.sale) { return +(100 * (line.sale / (100 - line.discount))).toFixed(2) }
    if (!!line.discount && !line.sale && !!line.cost) { return (line.cost) * ((line.profit / 100) + 1) }
  }

  async calculateTableDiff(lines, offer) {
    let b = lines.map(x => +x.totalSale).reduce((a, b) => a + b, 0);
    let t = offer.installationTimeInHours != 0 ? (offer.installationTimeInHours * offer.hoursSalesPrice) + offer.startingFee : 0;
    return offer.totalPrice - (b + t)
  }

  async handleSumTotals(object, texts, offer: Offer, lines, conditions, parentStyle) {
    let fontSizer = !!parentStyle.fontSize ? parentStyle.fontSize : 10;
    fontSizer = !!object.fontSize ? object.fontSize : fontSizer;
    // console.log(lines.filter(x => x.type == 'group'))
    let materials = await lines.filter(x => !['group', 'comment'].includes(x.type) && !x.priceGroupId).reduce((tot, curr) => tot = tot + curr.totalSale, 0);
    let hours = await lines.filter(x => !['group', 'comment'].includes(x.type) && !!x.priceGroupId).reduce((tot, curr) => tot = tot + curr.totalSale, 0);
    let customMaterial = offer.customLines.reduce((total, current) => { return total + (current.priceGroupId == null ? current.totalSalesPrice : 0) }, 0);
    let customHours = offer.customLines.reduce((total, current) => { return total + (current.priceGroupId != null ? current.totalSalesPrice : 0) }, 0);
    let productTotal = offer.productLines.reduce((total, current) => { return total + (current.listPrice * current.quantity) }, 0);
    let sub = this.nums(offer.totalPrice, texts['companyLingo']);
    let vat = this.nums((offer.totalPrice * 1.25) - offer.totalPrice, texts['companyLingo']);
    let totalPrice = this.nums(offer.totalPrice * 1.25, texts['companyLingo']);
    switch (object.totalType) {
      case ('normal'): {
        switch (conditions.companyLingo) {
          case ('da-DK'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'DKK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          case ('sv-SE'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'SEK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          case ('nn-NO'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'NOK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          default: {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'Euro', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
        }
      }
      case ('reduction'): {
        switch (conditions.companyLingo) {
          case ('da-DK'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Materialer\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Timer\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'DKK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: this.nums(materials, texts['companyLingo']) + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: this.nums(hours, texts['companyLingo']) + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          case ('sv-SE'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'SEK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          case ('nn-NO'): {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'NOK', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
          default: {
            return {
              unbreakable: true,
              table: {
                widths: ['*', 165],
                lineWidth: 1,
                headerRows: 1,
                body: [
                  ['', ''],
                  ['', {
                    columns: [
                      [
                        { text: 'Subtotal\n', alignment: 'left', margin: [0, 5, 0, 2] },
                        { text: 'Moms\n', alignment: 'left', margin: [0, 2, 0, 2] },
                        { text: 'Total ' + 'Euro', alignment: 'left', margin: [0, 2, 0, 5], bold: true }
                      ],
                      [
                        { text: sub + '\n', alignment: 'right', margin: [0, 5, 0, 2] },
                        { text: vat + '\n', alignment: 'right', margin: [0, 2, 0, 2] },
                        { text: totalPrice, alignment: 'right', margin: [0, 2, 0, 5], bold: true }
                      ]
                    ],
                    width: 140
                  }]
                ]
              },
              layout: 'headerLineOnly',
              fontSize: fontSizer
            }
          }
        }
      }
    }
  }

  async handleAbsolute(object, texts, offer, conditions, placement, images, parentStyle, lines) {
    let absolute = await this.handleSubItem(object.singleItem, texts, offer, conditions, placement, images, parentStyle, lines);
    absolute[object.text] = { x: object.fit[0], y: object.fit[1] }
    return absolute
  }

  async handleDate(object, parentStyle, conditions) {
    let options = { day: object.dateSettings.day, month: object.dateSettings.month, year: object.dateSettings.year }
    let date = {};
    if (!!object.margin) { date['margin'] = object.margin }
    if (!!object.color) { date['color'] = object.color }
    if (!!object.lineHeight) { date['lineHeight'] = object.lineHeight }
    if (!!object.fontSize) { date['fontSize'] = object.fontSize }
    if (!!object.font) { date['font'] = object.font }
    if (!!object.bold) { date['bold'] = object.bold }
    if (!!object.alignment) { date['alignment'] = object.alignment }
    if (!!object.italics) { date['italics'] = object.italics }
    if (!!object.link) { date['link'] = object.link }
    if (!!object.width && object.width <= 0) {
      date['width'] = object.width == 0 ? '*' : 'auto';
    }
    else { date['width'] = !!object.width ? object.width : '*' }
    switch (object.dateSettings.type) {
      case ('now'): {
        date['text'] = new Intl.DateTimeFormat(object.dateSettings.language, options).format(new Date()).toString();
        break
      }
      case ('nowPlus'): {
        let useDate = new Date(new Date().getFullYear(), new Date().getMonth(), (new Date().getDate() + +object.dateSettings.variable))
        date['text'] = new Intl.DateTimeFormat(object.dateSettings.language, options).format(useDate).toString();
        break
      }
      case ('set'): {
        date['text'] = object.dateSettings.variable ? new Intl.DateTimeFormat(object.dateSettings.language, options).format(new Date(object.dateSettings.variable)).toString() : '';
        break
      }
    }
    return date
  }

  translateNumberToPdfMakeWidth(width) {
    return width > 0 ? width : width == 0 ? '*' : 'auto'
  }

  async checkIfProductsHasDiscount(offer: Offer) {
    for (let x of offer.customLines) {
      if (!!x.discount && x.discount > 0) { return true }
    }
    for (let x of offer.productLines) {
      if (!!x.discount && x.discount > 0) { return true }
    }
    return false
  }

  async checkIfHourLineHasPrice(offer: Offer) {
    return (offer.hoursSalesPrice * offer.installationTimeInHours) + offer.startingFee > 0 ? true : false
  }

  nums(number: number, language) {
    if (!number) { return '' }
    return new Intl.NumberFormat(language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(+number.toFixed(2))
  }

  parentStyleToChild(parent, child) {
    if (!!parent.font) { child['font'] = parent['font'] }
    if (!!parent.width) { child['width'] = parent['width'] }
    if (!!parent.alignment) { child['alignment'] = parent['alignment'] }
    if (!!parent.fillColor) { child['fillColor'] = parent['fillColor'] }
    if (!!parent.margin) { child['margin'] = parent['margin'] }
    if (!!parent.lineHeight) { child['lineHeight'] = parent['lineHeight'] }
    return child
  }
}

export class ContentProvider {
  dateOptions = { day: 'numeric', month: 'long', year: "numeric" } as DateOptions
  public compDetails: CompanyInformation;
  public offDetails: GetOffer;
  public caseDetails: CaseDetails;
  public lines = [];
  private textByLanguage = new OfferCompanyTexts()
  public texts = {};
  public conditionals = {}
  private products = new DocumentCreatorGridConversions();
  private accounting = new ProductTableGroupAccounting();
  companyAddressStack: Object;
  companyAddressSingle: Object;
  customerAddressStack: Object;
  customerDeliveryAddressStack: Object;
  customerInvoiceAddressStack: Object;

  set companyDetails(c: CompanyInformation) {
    this.compDetails = c;
    this.createCompanyAddressStack();
    this.createCompanySingle();
    this.texts['companyName'] = c.name;
    if (c.address.includes(',')) {
      this.texts['companyAddress'] = c.address.split(',')[0];
      this.texts['companyZipCity'] = c.address.split(',')[1].trim();
      let zipEnd = this.texts['companyZipCity'].indexOf(' ');
      this.texts['companyZipCode'] = this.texts['companyZipCity'].slice(0, zipEnd).trim();
      this.texts['companyCity'] = this.texts['companyZipCity'].slice(zipEnd).trim();
    }
    else {
      this.texts['companyAddress'] = c.address;
      this.texts['companyZipCity'] = '';
      this.texts['companyZipCode'] = '';
      this.texts['companyCity'] = '';
    }
    this.texts['companyPhone'] = c.phone;
    this.texts['companyVAT'] = c.vat;
    this.texts['companyEmail'] = c.email;
    this.texts['companyWebPage'] = c.website;

    this.conditionals['companyLingo'] = c.companyLanguage;
  }

  async offerDetails(o: GetOffer) {
    let currencyStyle = {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 2
    }
    if (o != null) {
      this.offDetails = o;
      // this.lines = await this.linesMerger(o.customLines, o.productLines);
      // this.lines = (await this.products.documentToGrid(o)).filter(x => !x.hideOnPdf).map(x => {
      //   return { ...x, description: x.description.replace('[ProductGroupId]','').trim() }
      // });
      this.lines = await (await this.accounting.convertLinesToJoinedLines(o)).map(x => {
        return { ...x, description: x.description.replace('[ProductGroupId]', '').trim() }
      });
      this.texts['offerDate'] = format(new Date(o.sentAt || new Date().toISOString()), 'dd-MM-yyyy');
      this.texts['offerDisclaimer'] = o.disclaimer;
      this.texts['offerResponsible'] = o.responsible.name;
      this.texts['offerResponsibleTitle'] = o.responsible.title;
      this.texts['offerResponsibleInitials'] = this.extractResponsibleInitials(o.responsible.name);
      this.texts['offerWorkHours'] = o.installationTimeInHours;
      this.texts['offerDescription'] = o.technicalDescription;
      this.texts['offerNumber'] = !!o.consecutivelyOfferNumber ? o.offerNumber.toString() + '-' + o.consecutivelyOfferNumber.toString() : o.offerNumber;
      this.texts['offerTitle'] = o.title;
      this.texts['variationNumber'] = o.variationOrderNumber;
      this.texts['offerTotalIncVat'] = new Intl.NumberFormat('da-DK', currencyStyle).format(+(+o.totalPrice * 1.25).toFixed(2));
      this.texts['offerTotalExVat'] = new Intl.NumberFormat('da-DK', currencyStyle).format(+(+o.totalPrice).toFixed(2));
      this.texts['offerTotalVAT'] = new Intl.NumberFormat('da-DK', currencyStyle).format(+((+o.totalPrice * 1.25) - +o.totalPrice).toFixed(2));
      this.texts['[currentPage]'] = '[currentPage]';
      this.texts['[pageCount]'] = '[pageCount]';
      this.texts['offerResponsiblePhone'] = !!o.responsible.phone ? o.responsible.phone : '';
      this.texts['offerResponsibleEmail'] = !!o.responsible.email ? o.responsible.email : '';
      // if (o.responsible.countryCode) { this.texts['offerResponsibleCountryCode'] = o.responsible.countryCode }

      this.conditionals['offerDisclaimerIsEmpty'] = o.disclaimer == '' || o.disclaimer == null ? false : true;
      this.conditionals['offerDescriptionIsEmpty'] = o.technicalDescription == '' || o.technicalDescription == null ? false : true;
      this.conditionals['includeProductPage'] = o.includeProductPage;
      this.conditionals['showProductLines'] = o.showProductLines;
      this.conditionals['showHours'] = o.showHours;
    }
  }

  async linesMerger(custom, products) {

    let lines = [];
    for (let c of custom) {
      let item = await {
        id: c.id,
        description: c.name,
        number: '',
        cost: c.costPrice,
        sale: c.salesPrice,
        profit: c.profit,
        discount: c.discount,
        amount: c.quantity,
        image: '',
        sortOrder: c.sortOrder,
        totalCost: c.totalCostPrice,
        totalSale: c.totalSalesPrice,
        wholesaler: '',
        type: 'custom',
        companyProduct: false,
        manufacturer: '',
        priceGroupId: c.priceGroupId
      }
      await lines.push(item)
    }
    for (let p of products) {
      let item = await {
        id: p.productId,
        description: p.description,
        number: p.productNumber,
        cost: p.costPrice,
        sale: p.listPrice,
        profit: p.profit,
        discount: p.discount,
        amount: p.quantity,
        image: p.image,
        sortOrder: p.sortOrder,
        totalCost: p.totalCostPrice,
        totalSale: p.listPrice * p.quantity,
        wholesaler: p.wholeSaler,
        type: 'product',
        companyProduct: p.companyProduct,
        manufacturer: p.manufacturer,
        priceGroupId: null
      }
      await lines.push(item)
    }
    return lines.sort((a, b) => { return a.sortOrder > b.sortOrder ? 1 : -1 })
  }

  case(c: CaseDetails) {
    this.caseDetails = c;
    this.createCustomerAddressStack();
    this.createCustomerDeliveryAddressStack();
    this.createCustomerInvoiceAddressStack();
    this.createContactAddressStack();
    this.texts['customerNumber'] = c.customerNumber;
    this.texts['customerName'] = c.customer.name;
    this.texts['customerAddress'] = c.customer.address;
    this.texts['customerZipCode'] = c.customer.zipCode;
    this.texts['customerCity'] = c.customer.city;
    this.texts['customerZipCity'] = c.customer.zipCode + ' ' + c.customer.city;
    this.texts['customerPhone'] = c.customer.phone;
    this.texts['customerMobile'] = c.customer.mobile;
    this.texts['customerEmail'] = c.customer.email;
    this.texts['customerVAT'] = !!c.customer.cvr ? c.customer.cvr : '';
    this.texts['customerDeliveryName'] = c.deliveryAddress.name;
    this.texts['customerDeliveryAddress'] = c.deliveryAddress.address;
    this.texts['customerDeliveryZipCode'] = c.deliveryAddress.zipCode;
    this.texts['customerDeliveryCity'] = c.deliveryAddress.city;
    this.texts['customerDeliveryZipCity'] = c.deliveryAddress.zipCode + ' ' + c.deliveryAddress.city;
    this.texts['customerDeliveryPhone'] = c.deliveryAddress.phone;
    this.texts['customerDeliveryEmail'] = c.deliveryAddress.email;
    this.texts['customerInvoiceName'] = c.invoice.name;
    this.texts['customerInvoiceAddress'] = c.invoice.address;
    this.texts['customerInvoiceZipCode'] = c.invoice.zipCode;
    this.texts['customerInvoiceCity'] = c.invoice.city;
    this.texts['customerInvoiceZipCity'] = c.invoice.zipCode + ' ' + c.invoice.city;
    this.texts['customerInvoicePhone'] = c.invoice.phone;
    this.texts['customerInvoiceEmail'] = c.invoice.email;
    this.texts['contactName'] = c.contactAddress && c.contactAddress.name ? c.contactAddress.name : '';
    this.texts['contactAddress'] = c.contactAddress && c.contactAddress.address ? c.contactAddress.address : '';
    this.texts['contactZipCode'] = c.contactAddress && c.contactAddress.zipCode ? c.contactAddress.zipCode : '';
    this.texts['contactZipCity'] = c.contactAddress && c.contactAddress.zipCode + ' ' + c.contactAddress.city;
    this.texts['contactCity'] = c.contactAddress && c.contactAddress.city ? c.contactAddress.city : '';
    this.texts['contactPhone'] = c.contactAddress && c.contactAddress.phone ? c.contactAddress.phone : '';
    this.texts['contactEmail'] = c.contactAddress && c.contactAddress.email ? c.contactAddress.email : '';
    this.texts['requisitionNumber'] = c.requisitionNumber;
    this.texts['ourReference'] = c.vorRef != null ? c.vorRef : '';
    this.conditionals['noRequisitionNumber'] = c.requisitionNumber == null || c.requisitionNumber == '' ? false : true;
    this.conditionals['customerAndDeliveryAddressSame'] = !c.deliveryAddress.id || !!c.deliveryAddress.address && !!c.deliveryAddress.name && !!c.customer.address && c.deliveryAddress.address.toLowerCase() == c.customer.address.toLowerCase() && c.deliveryAddress.name.toLowerCase() == c.customer.name.toLowerCase() ? false : true;
    this.conditionals['noDeliveryAddress'] = !c.deliveryAddress.id;
    this.conditionals['customerHasCustomerNumber'] = c.customerNumber != null && c.customerNumber != '' ? true : false;
    this.conditionals['noReference'] = !c.vorRef;
  }

  async createCompanyAddressStack() {
    let a = await this.compDetails.address.includes(',') ? this.compDetails.address.split(',')[0] : this.compDetails.address;
    let zipCity = await this.compDetails.address.includes(',') ? this.compDetails.address.split(',')[1] : '';
    this.texts['companyAddressStack'] = {
      stack: [
        { text: this.compDetails.name, bold: true },
        { text: a },
        { text: zipCity }
      ]
    }
    this.companyAddressStack = {
      stack: [
        { text: this.compDetails.name, bold: true },
        { text: a },
        { text: zipCity }
      ]
    }
  }

  createCustomerAddressStack() {
    this.texts['customerAddressStack'] = {
      stack: [
        { text: this.caseDetails.customer.name, bold: true },
        { text: this.caseDetails.customer.address },
        { text: this.caseDetails.customer.zipCode + ' ' + this.caseDetails.customer.city }
      ]
    }
  }

  createCustomerInvoiceAddressStack() {
    this.texts['customerInvoiceAddressStack'] = {
      stack: [
        { text: this.caseDetails.invoice.name, bold: true },
        { text: this.caseDetails.invoice.address },
        { text: this.caseDetails.invoice.zipCode + ' ' + this.caseDetails.invoice.city }
      ]
    }
  }

  createContactAddressStack() {
    if (this.caseDetails.contactAddress && this.caseDetails.contactAddress.id) {
      this.texts['contactAddressStack'] = {
        stack: [
          { text: this.caseDetails.contactAddress.name, bold: true },
          { text: this.caseDetails.contactAddress.address },
          { text: this.caseDetails.contactAddress.zipCode + ' ' + this.caseDetails.deliveryAddress.city }
        ]
      }
    }
    else {
      this.texts['contactAddressStack'] = { text: '' }
    }
  }

  createCustomerDeliveryAddressStack() {
    if (this.caseDetails.deliveryAddress.id) {
      this.texts['customerDeliveryAddressStack'] = {
        stack: [
          { text: this.deNull(this.caseDetails.deliveryAddress.name), bold: true },
          { text: this.deNull(this.caseDetails.deliveryAddress.address) },
          { text: this.deNull(this.caseDetails.deliveryAddress.zipCode) + ' ' + this.deNull(this.caseDetails.deliveryAddress.city) }
        ]
      }
    }
    else {
      this.texts['customerDeliveryAddressStack'] = { text: '' }
    }
  }

  createCompanySingle() {
    let c = this.compDetails;
    let text = this.textByLanguage.getFixedTexts(c.companyLanguage);
    this.texts['companyAddressSingle'] = { text: c.name + ' • ' + c.address + ' • ' + text.extraTexts.phone + ': ' + c.phone + ' • ' + text.extraTexts.vat + ': ' + c.vat }
    this.companyAddressSingle = { text: c.name + ' • ' + c.address + ' • ' + text.extraTexts.phone + ': ' + c.phone + ' • ' + text.extraTexts.vat + ': ' + c.vat }
  }

  extractResponsibleInitials(t: string) {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let nameString = ''
    if (t == null) return ''
    t = t.replace(/\s\s+/g, ' ');
    if (t.split(' ').length > 1) {
      let a = t.split(' ');
      for (let i = 0; i < a.length; i++) {
        if (a[i] != '') {
          nameString = nameString + a[i][0].toUpperCase()
        }
      }
      return nameString
      //return t.split(' ').map(x => x.split('')[0].toUpperCase()).join('');
    }
    else { return t }
  }

  deNull(text) {
    return !!text ? text : ''
  }
}

export class pdfParts {
  name: string;
  type: 'text' | 'image' | 'line' | 'columns' | 'table' | 'stack' | 'compositeText' | 'none' | 'productTable' | 'productPage' | 'sumTotal' | 'absolute' | 'link' | 'date';
  totalType?: 'normal' | 'standard';
  margin?: [number, number, number, number];
  fit?: [number, number];
  alignment?: 'justify' | 'center' | 'left' | 'right';
  image?: string;
  fontSize?: number;
  bold?: boolean;
  italics?: boolean;
  color?: string;
  text?: any;
  columns?: Array<pdfParts>;
  lineHeight?: number;
  textType?: 'fixed' | 'dynamic' | 'formatted' | 'free';
  dateSettings?: DateOptions;
  width?: number;
  gap?: number;
  tableType?: 'none' | 'header' | 'horizontal' | any;
  headers?: number;
  tableWidths?: Array<number>;
  tableRows?: Array<Array<pdfParts>>;
  lineWidth?: number;
  condition?: string;
  translates?: any;
  singleItem?: pdfParts;
  font?: string;
  unbreakable?: boolean;
  link?: string;
  position?: any;
  pageBreak?: 'before' | 'after' | 'none';
}

export class DateOptions {
  language: string;
  day: '2-digit' | 'numeric' = '2-digit';
  month: '2-digit' | 'numeric' | 'narrow' | 'short' | 'long' = 'long';
  year: '2-digit' | 'numeric' = '2-digit';
  type: 'now' | 'nowPlus' | 'set' = 'now';
  variable;
}

interface defaultStyle {
  fontSize?: number;
  bold?: boolean;
  color?: string;
  italics?: boolean;
  lineHeight?: number;
  margin?: [number, number, number, number];
  text?: string;
  width?: number | '*' | 'auto';
  alignment?: 'left' | 'center' | 'right' | 'justify';
}

export class Images {
  name: string;
  base64: string;
  id: string;
  removeable: boolean;
}

export class TableContent {
  layout?: 'noBorders' | 'headerLineOnly' | 'lightHorizontalLines' | Object
  table: TableItem;
  margin?: [number, number, number, number]
}

export class TableItem {
  headerRows?: number;
  body: Array<any>;
  widths?: Array<string | number>
}

export class HtmlToPdfMake {

  public async parseToPdf(html, defaultStyle) {
    // console.log(html)
    let level = 0;
    let pageBreak = false;
    let withinListItem = false;
    let listItemHasABreak = 0;
    let inUnorderedList = false;
    if (!html.includes('<') && !html.includes('>')) {
      return [{ text: html }]
    }
    //html = await html.split('\n').join('<br />')
    // The head style property is used as a reference for child elements and is styled in relation to this.
    // This is done, so that if the pdf design requires a larger font, tinyMCE (default font-size of 10px) will scale appropriately.
    let headStyle = await !!defaultStyle ? defaultStyle : { fontSize: 10, bold: false, italics: false, lineHeight: 1, margin: [0, 0, 0, 0] };
    // CurrentStyle is sent with every element to propagate set styles
    let currentStyle = {};
    // The outputStack will contain the final output of the parsed html
    let outputStack = [];
    // Since html is folder structure, the currentLevel will contain the parent folders as an array
    // currentLevel can include {text:[]} , {ol:[]}, {ul:[]}, {stack:[]}
    let currentLevel = [];
    // The current Array contains the content that will go into the parent content when going up one level in the folder structure
    let currentArray = [];
    // Current text includes an array of styled text elements. 
    let currentText: any = { text: [] }
    let underline = {
      use: false,
      level: 0
    }
    let steps = [];
    for (let splitElement of html.split('<')) {
      let element = await this.elementTextExtract(splitElement, defaultStyle);
      // har fortfarande inte styleat något..
      steps.push('processing the element ' + JSON.stringify(element));
      if (underline.use && level > underline.level) { currentText['decoration'] = 'underline' }
      else if (underline.use && level == underline.level) { delete currentText['decoration'] }
      if (!!element.style && Object.keys(element.style).length > 0) {
        if (!!element.style['decoration']) {
          console.log('found an underline in level ', level)
          underline.use = true;
          underline.level = level;
        }
      }

      switch (element.tag) {
        case ('b'): {
          level += 1;
          currentStyle['bold'] = true;
          steps.push('   setting currentStyle to bold')

          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('   element styling :' + JSON.stringify(element.style));
            steps.push('   making current style into ' + JSON.stringify(currentStyle))
          }
          if (!!element.text) {
            currentText.text.push({ text: element.text, bold: true })
          }
          ; break
        }
        case ('/b'): {
          level -= 1;
          delete currentStyle['bold'];
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          steps.push('   setting currentStyle to non-bold')
            ; break
        }
        case ('strong'): {
          level += 1;
          currentStyle['bold'] = true;
          steps.push('   setting currentStyle to bold')
          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('   element styling :' + JSON.stringify(element.style));
            steps.push('   making current style into ' + JSON.stringify(currentStyle))
          }
          if (!!element.text) {
            currentText.text.push({ text: element.text, bold: true })
          }
          ; break
        }
        case ('/strong'): {
          level -= 1;
          delete currentStyle['bold'];
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          steps.push('   setting currentStyle to non-bold')
            ; break
        }
        case ('br'): {
          // is the break row inside a list or not?
          if (withinListItem) {
            steps.push('    soft enter within a list item')
            //listItemHasABreak += 1;
            if (!!currentText.text && currentText.text.length > 0) {
              currentText.text.push({ text: '\n' })
            }
            if (!!element.text && element.text != '') {
              steps.push('    Found a text after the break row', element.text)
              currentText.text.push({ text: element.text })
            }
            steps.push('   Breaking row in list makes me add a break row currentText');
          }
          else {
            if (!!currentText.text && currentText.text.length > 0) {
              currentArray.push(currentText);
              currentText = { text: [] }
            }
            if (!!element.text && element.text != '') {
              steps.push('    Found a text after the break row', element.text)
              currentText.text.push({ text: element.text })
            }
            steps.push('   Breaking row makes me add currentText to the currentArray');
          }
          break
        }
        case ('em'): {
          level += 1;
          currentStyle['italics'] = true;
          steps.push('   setting currentStyle to italic');
          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('   element styling :' + JSON.stringify(element.style));
            steps.push('   making current style into ' + JSON.stringify(currentStyle))
          }
          if (!!element.text) {
            currentText.text.push({ text: element.text, italics: true })
          }
          ; break
        }
        case ('/em'): {
          level -= 1;
          delete currentStyle['italics'];
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          steps.push('   setting currentStyle to non-italic');
          ; break
        }
        case ('i'): {
          level += 1;
          currentStyle['italics'] = true;
          steps.push('   setting currentStyle to italic');
          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('   element styling :' + JSON.stringify(element.style));
            steps.push('   making current style into ' + JSON.stringify(currentStyle))
          }
          if (!!element.text) {
            currentText.text.push({ text: element.text, italics: true })
          }
          ; break
        }
        case ('/i'): {
          level -= 1;
          delete currentStyle['italics'];
          steps.push('   setting currentStyle to non-italic');
          ; break
        }
        case ('span'): {
          level += 1;
          steps.push('   Finding a span, so adding :' + element.text + ' to currentText');
          let text = { text: element.text };
          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('Found a style on the element and changed currentStyle to ' + JSON.stringify(currentStyle))
            for (let s of Object.keys(currentStyle)) {
              text[s] = await currentStyle[s]
            }
            currentText.text.push(text)
          }
          else {
            currentText.text.push(text);
          }
          break
        }
        case ('/span'): {
          level -= 1;
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          steps.push('   Span ending and currentText is now equal to :' + JSON.stringify(currentText))
            ; break
        }
        case ('ol'): {
          level += 1;
          // await add current style to stack
          let list = { ol: [], margin: [15, 0, 0, 5] };
          if (!!element.style && !!element.style['listType']) {
            list['type'] = element.style['listType'].trim()
          }
          if (currentText.text.length != 0) { currentArray.push(currentText); currentText = { text: [] } }
          if (currentArray.length != 0) {
            if (currentLevel.length > 0) {
              // The list is within another object, guessing it's another list, so first need to pop the list items above and then pop the list to put them in.
              let l = currentLevel.pop();
              let new_l = await this.pushArrayIntoParent(l, currentArray);
              steps.push('pushed currentArray to last in currentLevel', JSON.stringify(new_l))
              currentLevel.push(new_l);
              currentArray = [];
            }
          }
          currentLevel.push(list);
          break
        }
        case ('/ol'): {
          level -= 1;
          let list = currentLevel.pop();
          list.ol = list.ol.concat(currentArray);
          if (currentText.text.length > 0) { list.stack.push(currentText) }
          if (currentLevel.length == 0) {
            outputStack.push(list)
            currentArray = [];
          }
          else { currentArray = [list] }
          currentText = { text: [] };
          break
        }
        case ('ul'): {
          level += 1;
          // await add current style to stack
          //let list = { ul: [], margin: [15, 0, 0, 10] };
          let list = { ul: [], margin: [15, 0, 0, 0] };
          if (!!element.style && !!element.style['listType']) {
            list['type'] = element.style['listType'].trim()
          }
          else if (element.style == null && inUnorderedList == true) {
            element.style['listType'] = 'circle';
          }
          steps.push('Unordered list started : currentLevel ' + currentLevel.length.toString());
          if (currentText.text.length != 0) { currentArray.push(currentText); currentText = { text: [] } }
          if (currentArray.length != 0) {
            if (currentLevel.length > 0) {
              // The list is within another object, guessing it's another list, so first need to pop the list items above and then pop the list to put them in.
              let l = currentLevel.pop();
              let new_l = await this.pushArrayIntoParent(l, currentArray);
              steps.push('pushed currentArray to last in currentLevel', JSON.stringify(new_l))
              currentLevel.push(new_l);
              currentArray = [];
            }
          }
          await currentLevel.push(list);
          inUnorderedList = true;
          break
        }
        case ('/ul'): {
          level -= 1;
          steps.push('Retrieving last level of lists and pushing', JSON.stringify(currentLevel));
          let list = currentLevel.pop();
          steps.push('The retrieved list should then get the currentArray', JSON.stringify(currentArray))
          list.ul = list.ul.concat(currentArray);
          if (currentText.text.length > 0) { list.stack.push(currentText) }
          if (currentLevel.length == 0) {
            steps.push('item pushed to outputStack')
            outputStack.push(list)
            currentArray = [];
          }
          else {
            steps.push('Still levels available, putting this list into currentArray', JSON.stringify(list));
            currentArray = [list];
          }
          currentText = { text: [] };
          break
        }
        case ('li'): {
          level += 1;
          if (!!element.text) {
            currentText.text.push({ text: element.text });
          }
          withinListItem = true;
          currentLevel.push({ text: [] })
          break
        }
        case ('/li'): {
          level -= 1;
          let listItem = currentLevel.pop();
          withinListItem = false;
          steps.push('   List item is closing and the currentText is :' + JSON.stringify(currentText, null, 4))
          currentArray.push(currentText);
          if (listItemHasABreak > 0) {
            steps.push('   List Item should have a break . Amount = ' + listItemHasABreak);
            for (let i = 1; i < listItemHasABreak; i++) {
              currentArray.push({ text: ' ', listType: 'none' })
            }
          }
          steps.push('   Adding the text to currentArray :' + JSON.stringify(currentArray, null, 4))
          currentText = { text: [] };
          currentArray = listItem.text.concat(currentArray);
          //currentArray = [listItem];
          listItemHasABreak = 0;
          ; break
        }
        case ('div'):
        case ('p'): {
          level += 1;
          // await add current style to stack
          currentLevel.push({ stack: [], margin: [0, 10, 0, 5] });
          if (!!element.text) {
            currentText.text.push({ text: element.text })
          }
          steps.push('   Paragraph tag so added a stack to currentLevel :' + JSON.stringify(currentLevel))
          break
        }
        case ('/div'):
        case ('/p'): {
          level -= 1;
          steps.push('   Paragraph tag ended so removing the last currentLevel' + JSON.stringify(currentLevel))
          let paragraph = currentLevel.pop();
          steps.push('   Paragraph should have a stack property :' + (!!paragraph.stack).toString())
          steps.push('   Having removed the stack from the currentLevel I proceed to pass the currentArray into it :' + JSON.stringify(currentArray))
          paragraph.stack = currentArray;
          if (currentText.text.length > 0) {
            steps.push('   If there is a trailing text in currentText, I add it to the stack :' + JSON.stringify(currentText))
            paragraph.stack.push(currentText)
          }
          if (currentLevel.length == 0) {
            pageBreak == false ? outputStack.push(paragraph) : outputStack.push({ ...paragraph, pageBreak: 'after' });
            pageBreak = false;
            currentArray = [];
          }
          else { currentArray = [paragraph] }
          currentText = { text: [] };
          break
        }
        case ('h3'): {
          level += 1;
          steps.push('   Found a H3 tag:' + element.text + 'was added to current Text')
          let text = { text: element.text, fontSize: 11, bold: true };
          if (Object.keys(element.style).length > 0) {
            currentStyle = await this.changeCurrentStyle(element, currentStyle, headStyle);
            steps.push('Found a style on the element and changed currentStyle to ' + JSON.stringify(currentStyle))
            for (let s of Object.keys(currentStyle)) {
              text[s] = await currentStyle[s]
            }
            currentText.text.push(text)
          }
          else {
            currentText.text.push(text);
          }
          ; break
        }
        case ('/h3'): {
          level -= 1;
          steps.push('   H3 ended and currentText is now equal to :' + JSON.stringify(currentText))
            ; break
        }
        case ('a'): {
          level += 1;
          steps.push('   Found a link :' + element.text + ' to currentText');
          let text = { text: element.text, color: 'blue' };
          if (element.link) { text['link'] = element.link };
          currentText.text.push(text);
          break;
        }
        case ('/a'): {
          level -= 1;
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          ; break
        }
        case ('!--'): {
          pageBreak = true;
          steps.push('    Found a page break')
          currentText.text.push({ text: '', pageBreak: 'before' })
          break
        }
        case ('u'): {
          level += 1;
          steps.push('Found an underline tag');
          let text = { text: element.text, decoration: 'underline' };

          currentText.text.push(text);

          break
        }
        case ('/u'): {
          level -= 1;
          if (element.text != null && element.text != '') {
            let text = { text: element.text };
            currentText.text.push(text);
          }
          break
        }
        default: { }
      }
      steps.push('currentText', JSON.stringify(currentText), 'currentArray', JSON.stringify(currentArray), 'currentLevel', JSON.stringify(currentLevel), '\n')
    }
    if (currentText.text.length != 0) {
      currentArray.push(currentText)
    }
    if (currentArray.length != 0 && currentLevel.length != 0) {
      let a = currentLevel.pop();
      a.stack = currentArray;
      outputStack.push(a)
    }
    // Uncomment line below to export 
    // console.log(steps)
    //this.saveTextAsFile(steps.join('\n'))
    //this.saveTextAsFile(JSON.stringify(outputStack, null, 4))
    //console.log(currentText, currentArray, currentLevel)
    // console.log(steps.join('\n'))
    return outputStack
  }

  pushArrayIntoParent(item, array) {
    if (Object.keys(item).includes('text')) {
      item.text = item.text.concat(array);
      return item
    }
    if (Object.keys(item).includes('ol')) {
      item.ol = item.ol.concat(array);
      return item
    }
    if (Object.keys(item).includes('ul')) {
      item.ul = item.ul.concat(array);
      return item
    }
    if (Object.keys(item).includes('stack')) {
      item.stack = item.stack.concat(array);
      return item
    }
  }

  public startingStyle: defaultStyle;

  private async elementTextExtract(element, parentStyle) {
    let item = { tag: '', text: '', style: {}, link: null }
    item.tag = this.findTag(element.split('>')[0])
    item.style = await this.htmlElementStyle(element.split('>')[0], parentStyle)
    item.text = this.htmlToText(element.split('>')[1])
    if (element.includes('href=')) {
      item['link'] = element.split('href="')[1].split('"')[0]
    }
    return item
  }

  private findTag(element) {
    return element.includes(' ') ? element.split(' ')[0] : element
  }

  private async htmlElementStyle(element: string, parentStyle) {
    let a = {}
    let splitString = 'style="';
    if (element.includes(splitString)) {
      let styleElement = element.slice(element.indexOf(splitString) + splitString.length);
      for (let style of styleElement.slice(0, styleElement.indexOf('"')).split(';')) {
        if (style != '' && style.includes(':')) {
          let b: keyValue = await this.styleTranslate(style.split(':'), parentStyle)
          if (!!b && b.key != '') { a[b.key] = b.value; }
        }
      }
    }
    return a
  }

  styleTranslate(styleArray, parentStyle) {
    switch (styleArray[0].trim()) {
      case ('font-size'): {
        if (styleArray[1].includes('px')) {
          return { key: 'fontSize', value: Math.round(+(styleArray[1].replace('px', '')) * 0.75292857248934) }
        }
        else if (styleArray[1].includes('pt')) { return { key: 'fontSize', value: +(styleArray[1].replace('pt', '')) } }
        else if (styleArray[1].includes('%')) {
          let deStyled = +(styleArray[1].replace('%', ''));
          if (!!parentStyle.fontSize) { return { key: 'fontSize', value: ((deStyled / 100) * parentStyle.fontSize) } }
          else { return { key: 'fontSize', value: ((deStyled / 100) * 10) } }
        }
        return null
      }
      case ('list-style-type'): {
        return { key: 'listType', value: styleArray[1] }
      }
      case ('line-height'): {
        return { key: 'lineHeight', value: +styleArray[1] }
      }
      case ('text-decoration'): {
        return { key: 'decoration', value: styleArray[1].trim() }
      }
      default: { return { key: '', value: '' } }
    }
  }

  private async changeCurrentStyle(element, style, mainStyle) {
    for (let s of Object.keys(element.style)) {
      if (s == 'fontSize') {
        style[s] = await (+mainStyle.fontSize + (+element.style.fontSize - 10))
      }
      else {
        style[s] = await element.style[s]
      }
    }
    return style
  }

  public htmlToText(text) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = text;
    return tmp.textContent;
  }

  public saveTextAsFile(data) {
    var blob = new Blob([data], { type: 'text/plain' });
    var e = document.createEvent('MouseEvents'),
      a = document.createElement('a');

    a.download = 'PDF_Creator_Troubleshooter.txt';
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
    document.createEvent('click');
    a.dispatchEvent(e);
    //window.open(JSON.stringify(data));
  }
}

export class HtmlParsingSettings {
  margin: 0;
  bold: false;
  italics: false;
  fontSize: 10;
  decoration: false;
  link: false;
  end: false;
  listType: string;
}

interface keyValue {
  key: string;
  value: string;
}

export class OfferCompanyTexts {
  getFixedTexts(companyLanguage: string) {
    switch (companyLanguage) {
      case ('da-DK'): {
        return {
          offerData: [
            { key: 'companyName', value: 'Firma navn' },
            { key: 'companyAddress', value: 'Firma adresse' },
            { key: 'companyZipCode', value: 'Firma postnr.' },
            { key: 'companyCity', value: 'Firma by' },
            { key: 'companyZipCity', value: 'Firma postnr. og by' },
            { key: 'companyPhone', value: 'Firma telefon' },
            { key: 'companyEmail', value: 'Firma email' },
            { key: 'customerName', value: 'Kunde navn' },
            { key: 'customerAddress', value: 'Kunde adresse' },
            { key: 'customerZipCode', value: 'Kunde postnr.' },
            { key: 'customerCity', value: 'Kunde by' },
            { key: 'customerZipCity', value: 'Kunde postnr. og by' },
            { key: 'customerPhone', value: 'Kunde telefon' },
            { key: 'customerEmail', value: 'Kunde email' },
            { key: 'offerDisclaimer', value: 'Tilbud forbehold' },
            { key: 'offerResponsible', value: 'Tilbud ansvarlig' },
            { key: 'offerWorkHours', value: 'Tilbud timer' },
            { key: 'offerDescription', value: 'Tilbud beskrivelse' },
            { key: 'offerTotalIncVat', value: 'Tilbud total inkl.' },
            { key: 'offerTotalExVat', value: 'Tilbud total ekskl.' }
          ],
          extraTexts: {
            vat: 'CVR',
            phone: 'TLF'
          }
        }
      }
      case ('sv-SE'): {
        return {
          offerData: [
            { key: 'companyName', value: 'Firma namn' },
            { key: 'companyAddress', value: 'Firma adress' },
            { key: 'companyZipCode', value: 'Firma postnr.' },
            { key: 'companyCity', value: 'Firma stad' },
            { key: 'companyZipCity', value: 'Firma postnr. och stad' },
            { key: 'companyPhone', value: 'Firma telefon' },
            { key: 'companyEmail', value: 'Firma email' },
            { key: 'customerName', value: 'Kunde namn' },
            { key: 'customerAddress', value: 'Kund adress' },
            { key: 'customerZipCode', value: 'Kund postnr.' },
            { key: 'customerCity', value: 'Kund stad' },
            { key: 'customerZipCity', value: 'Kund postnr. och stad' },
            { key: 'customerPhone', value: 'Kund telefon' },
            { key: 'customerEmail', value: 'Kund email' },
            { key: 'offerDisclaimer', value: 'Offert villkor' },
            { key: 'offerResponsible', value: 'Offert ansvarig' },
            { key: 'offerWorkHours', value: 'Offert timmar' },
            { key: 'offerDescription', value: 'Offert beskrivning' },
            { key: 'offerTotalIncVat', value: 'Offert total inkl.' },
            { key: 'offerTotalExVat', value: 'Offert total exkl.' }
          ],
          extraTexts: {
            vat: 'CVR',
            phone: 'TLF'
          }
        }
      }
      case ('nn-NO'): {
        return {
          offerData: [
            { key: 'companyName', value: 'Firma navn' },
            { key: 'companyAddress', value: 'Firma adresse' },
            { key: 'companyZipCode', value: 'Firma postnr.' },
            { key: 'companyCity', value: 'Firma by' },
            { key: 'companyZipCity', value: 'Firma postnr. og by' },
            { key: 'companyPhone', value: 'Firma telefon' },
            { key: 'companyEmail', value: 'Firma email' },
            { key: 'customerName', value: 'Kunde navn' },
            { key: 'customerAddress', value: 'Kunde adresse' },
            { key: 'customerZipCode', value: 'Kunde postnr.' },
            { key: 'customerCity', value: 'Kunde by' },
            { key: 'customerZipCity', value: 'Kunde postnr. og by' },
            { key: 'customerPhone', value: 'Kunde telefon' },
            { key: 'customerEmail', value: 'Kunde email' },
            { key: 'offerDisclaimer', value: 'Tilbud forbehold' },
            { key: 'offerResponsible', value: 'Tilbud ansvarlig' },
            { key: 'offerWorkHours', value: 'Tilbud timer' },
            { key: 'offerDescription', value: 'Tilbud beskrivelse' },
            { key: 'offerTotalIncVat', value: 'Tilbud total inkl.' },
            { key: 'offerTotalExVat', value: 'Tilbud total ekskl.' }
          ],
          extraTexts: {
            vat: 'CVR',
            phone: 'TLF'
          }
        }
      }
      default: {
        return {
          offerData: [
            { key: 'companyName', value: 'Firma navn' },
            { key: 'companyAddress', value: 'Firma adresse' },
            { key: 'companyZipCode', value: 'Firma postnr.' },
            { key: 'companyCity', value: 'Firma by' },
            { key: 'companyZipCity', value: 'Firma postnr. og by' },
            { key: 'companyPhone', value: 'Firma telefon' },
            { key: 'companyEmail', value: 'Firma email' },
            { key: 'customerName', value: 'Kunde navn' },
            { key: 'customerAddress', value: 'Kunde adresse' },
            { key: 'customerZipCode', value: 'Kunde postnr.' },
            { key: 'customerCity', value: 'Kunde by' },
            { key: 'customerZipCity', value: 'Kunde postnr. og by' },
            { key: 'customerPhone', value: 'Kunde telefon' },
            { key: 'customerEmail', value: 'Kunde email' },
            { key: 'offerDisclaimer', value: 'Tilbud forbehold' },
            { key: 'offerResponsible', value: 'Tilbud ansvarlig' },
            { key: 'offerWorkHours', value: 'Tilbud timer' },
            { key: 'offerDescription', value: 'Tilbud beskrivelse' },
            { key: 'offerTotalIncVat', value: 'Tilbud total inkl.' },
            { key: 'offerTotalExVat', value: 'Tilbud total ekskl.' }
          ],
          extraTexts: {
            vat: 'CVR',
            phone: 'TLF'
          }
        }
      }
    }
  }

}

interface Template {
  header: Array<pdfParts>;
  content: Array<pdfParts>;
  footer: Array<pdfParts>;
}